import { LoadingButton } from "@mui/lab";
import { Box, CircularProgress, Dialog, DialogContent } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import useAxiosInstance from "../../../hooks/useAxiosInstance";
import { API_RESULT, API_VERSION } from "../../../enums/common.enum";
import { errorToast, handleError } from "../../../utils/common";
import CustomDialogTitle from "../../../components/Common/customDialogTitle";
import { updateBusinessPanSchemaBorrower } from "../../../schemas/providers.schema";
import BorrowerBusinessPanValidate from "../SingleBorrower/Summary/components/BorrowerBusinessPanValidate";

const EditBusinessPanModal = ({
  showEditBusinessPanModal,
  setShowEditBusinessPanModal,
  borrowerInfo,
  setBorrowerInfo,
}: any) => {
  const [loading, setLoading] = useState(false);
  const privateInstance = useAxiosInstance();

  const handleSubmit = async (values: any, actions: any) => {
    let payload: any = {
      borrower_id: borrowerInfo?.borrower_id,
      business_pan_no: values?.business_pan_no,
    };

    setLoading(true);

    try {
      const result = await privateInstance.post(
        `${API_VERSION.V3}/borrowers`,
        payload,
      );
      if (result?.data?.status === API_RESULT.SUCCESS) {
        setShowEditBusinessPanModal(false);
        const resultResponse = result.data.response;
        setBorrowerInfo({
          ...borrowerInfo,
          business_pan_no: resultResponse?.business_pan_no,
        });
      } else {
        errorToast(result.data.message);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={showEditBusinessPanModal}
      onClose={() => setShowEditBusinessPanModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <CustomDialogTitle
        id="customized-dialog-title"
        onClose={() => setShowEditBusinessPanModal(false)}
      >
        Edit Business PAN Details
      </CustomDialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            business_pan_no: borrowerInfo?.business_pan_no || "",
          }}
          validationSchema={updateBusinessPanSchemaBorrower}
          onSubmit={(values: any, actions: any) => {
            actions.setSubmitting(false);
            handleSubmit(values, actions);
          }}
        >
          {(props: any) => {
            const { values, touched, errors, handleBlur, setFieldValue } =
              props;
            return (
              <Form>
                <BorrowerBusinessPanValidate
                  business_pan_no={values.business_pan_no}
                  handleBlur={handleBlur}
                  errors={errors}
                  touched={touched}
                  setFieldValue={setFieldValue}
                />
                <Box textAlign="center" mt={3}>
                  <LoadingButton
                    size="medium"
                    color="primary"
                    loading={loading}
                    loadingIndicator={
                      <CircularProgress size={20} sx={{ color: "#fff" }} />
                    }
                    variant="contained"
                    type="submit"
                  >
                    Update
                  </LoadingButton>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default EditBusinessPanModal;
